import { render } from "./MenuAction.vue?vue&type=template&id=10cf582c&scoped=true"
import script from "./MenuAction.vue?vue&type=script&lang=js"
export * from "./MenuAction.vue?vue&type=script&lang=js"

import "./MenuAction.vue?vue&type=style&index=0&id=10cf582c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cf582c"]])

export default __exports__